import React, { ErrorInfo, memo, useEffect, useRef } from "react";
import "./ErrorBoundary.css";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

const ErrorFallback = memo(({ resetErrorBoundaryState, error, errorInfo }: { resetErrorBoundaryState(): void; error: Error; errorInfo: ErrorInfo }) => {
    const { pathname } = useLocation();
    const originalPathName = useRef(pathname);

    useEffect(() => {
        if (originalPathName.current !== pathname) {
            resetErrorBoundaryState();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return (
        <div className="error-boundary-wrapper">
            <FontAwesomeIcon className="error-boundary-icon" color={MirageTheme.palette.error.main} icon={faTriangleExclamation} />
            <Typography variant="h5">Wooops! Something went wrong.</Typography>
            <Typography>{`Error Name: ${error.name}`}</Typography>
            <Typography>{`Error Message: ${error.message}`}</Typography>
            <Typography>{`Error Cause: ${error.cause}`}</Typography>
            <Typography>Error Stack:</Typography>
            <Typography>{error.stack}</Typography>
            <Typography>Component Stack:</Typography>
            <Typography>{errorInfo.componentStack}</Typography>
        </div>
    );
});

export default ErrorFallback;
